const resisterDate = () => {
  return {
    date: null
  };
};

export default {
  state: resisterDate(),
  getters: {
    getDate(state) {
      return state.date;
    }
  },
  mutations: {
    /**
     * 初期化
     */
    init(state) {
      Object.assign(state, resisterDate());
    },
    setDate(state, list) {
      state.date = list;
    }
  }
};
